module.exports = __webpack_public_path__ + "static/media/Social.eb147717.svg";